import React from "react";
import { Link } from "react-router-dom";
import api from "../../../Environment";
import Helper from "../../Helper/helper";
import { withToastManager } from "react-toast-notifications";
import ToastDemo from "../../Helper/toaster";
import { translate } from "react-multi-lang";
import configuration from "react-global-configuration";
import {
  StandalonePageHeader,
  StandalonePageLogo,
} from "../../Layouts/SubLayout/StandalonePageLogo";
import ProfileImageRails from "./ProfileImageRail";
import "./ProfileSelector.css";
import {
    profileRailAppearanceStyle,
    resolveDefaultProfileImage,
    resolveProfilePicture,
} from "./profileImage";

class ManageProfilesComponent extends Helper {
    state = {
        renderManageProfile: "",
        data: {thumbnail_id : ''},
        renderAddProfile: "",
        loading: true,
        activeProfile: [],
        loadingContent: null,
        buttonDisable: false,
        inputData: { picture: '' },
        imagePreviewUrl: null,
        addNewProfileOption: null,
        thumbnailLoading: true,
        profileThumbnail: {},

    };
    componentDidMount() {
        // view all sub profile
        this.viewProfiles();
        this.getThumbnails();
    }

    getThumbnails() {
        api.postMethod("profile_thumbnails").then((response) => {
            if (response.data.success === true) {
                this.setState({
                    thumbnailLoading: false,
                    profileThumbnail: response.data.data.profile_thumbnails,
                });
            } else {
                this.errorCodeChecker(response.data.error_code);
            }
        });
    }

    handleClick = (data, event) => {
        event.preventDefault();

        this.setState({ renderManageProfile: 1 });
        // console.log(data);
        this.setState({ data });

        this.render();
    };
    handleChangeImage = ({ currentTarget: input }) => {
        const inputData = { ...this.state.inputData };
        if (input.type === "file") {
            inputData[input.name] = input.files[0];
            this.setState({ inputData });
        }
        let reader = new FileReader();
        let file = input.files[0];

        reader.onloadend = () => {
            this.setState({
                imagePreviewUrl: reader.result
            });
        };
        if (file) {
            reader.readAsDataURL(file);
        }
    };

    handleSubmit = event => {
        event.preventDefault();
        let data;

        if (this.state.inputData.picture == '') {
            data = {
                sub_profile_id: this.state.data.sub_profile_id,
                name: this.state.data.name,
                age: this.state.data.age,
                thumbnail_id: this.state.data.thumbnail_id ? this.state.data.thumbnail_id : '',
            };
        } else {
            data = {
                sub_profile_id: this.state.data.sub_profile_id,
                name: this.state.data.name,
                picture: this.state.inputData.picture,
                age: this.state.data.age,
                thumbnail_id: this.state.data.thumbnail_id ? this.state.data.thumbnail_id : '',
            };
        }

        this.setState({
            loadingContent: this.props.t("button_loading"),
            buttonDisable: true
        });
        api.postMethod("edit-sub-profile", data).then(response => {
            if (response.data.success) {
                // this.props.history.push("/manage-profiles");
                ToastDemo(
                    this.props.toastManager,
                    response.data.message,
                    "success"
                );
                this.setState({ loadingContent: null, buttonDisable: false });
                window.location = "/manage-profiles";
            } else {
                ToastDemo(
                    this.props.toastManager,
                    response.data.error_messages,
                    "error"
                );
                this.setState({ loadingContent: null, buttonDisable: false });
            }
        });
    };

    handleDelete = (event, sub_profile_id) => {
        event.preventDefault();

        const data = {
            delete_sub_profile_id: sub_profile_id
        };

        api.postMethod("sub_profiles/delete", data).then(response => {
            if (response.data.success) {
                ToastDemo(
                    this.props.toastManager,
                    response.data.message,
                    "success"
                );
                localStorage.setItem(
                    "active_profile_id",
                    response.data.sub_profile_id
                );

                window.location = "/manage-profiles";
            } else {
                ToastDemo(
                    this.props.toastManager,
                    response.data.error_messages,
                    "error"
                );
            }
        });
    };

    backToManageProfile = event => {
        event.preventDefault();
        this.setState({ renderManageProfile: 0 });
        this.setState({ renderAddProfile: 0 });

        this.render();
    };

    addProfile = event => {
        event.preventDefault();
        this.setState({ renderAddProfile: 1 });
        this.setState({ renderManageProfile: 0 });
        this.setState({ data: {} });

        this.render();
    };

    handleAddProfileSubmit = event => {
        event.preventDefault();
        let data;
        if (this.state.inputData.picture == '') {
            data = {
                name: this.state.data.name,
                age: this.state.data.age,
                thumbnail_id: this.state.data.thumbnail_id ? this.state.data.thumbnail_id : '',
            };
        } else {
            data = {
                name: this.state.data.name,
                picture: this.state.inputData.picture,
                age: this.state.data.age,
                thumbnail_id: this.state.data.thumbnail_id ? this.state.data.thumbnail_id : '',
            };
        }

        api.postMethod("add-profile", data).then(response => {
            if (response.data.success === true) {
                window.location = "/manage-profiles";
                ToastDemo(
                    this.props.toastManager,
                    response.data.message,
                    "success"
                );
            } else {
                ToastDemo(
                    this.props.toastManager,
                    response.data.error_messages,
                    "info"
                );
            }
        });
    };

    renderProfile = activeProfile => {
        return (
            <React.Fragment>
                {activeProfile.map(detail => (
                    <li className="profile" key={detail.sub_profile_id}>
                        <Link
                            onClick={event => this.handleClick(detail, event)}
                            to="#"
                        >
                            <span className="profile-selector__spotlight" aria-hidden="true" />
                            <span className="profile-selector__shape" aria-hidden="true" />
                            <div className="relative profile-selector__avatar">
                                <img
                                    src={detail.picture}
                                    className="profile-img"
                                    alt={detail.name}
                                />
                                <div className="edit-overlay">
                                    <div className="edit-icon-outline">
                                        <i className="fas fa-pencil-alt" />
                                    </div>
                                </div>
                            </div>
                            <p className="profile-name">{detail.name}</p>
                        </Link>
                    </li>
                ))}
            </React.Fragment>
        );
    };

    render() {
        const { t } = this.props;

        var bgImg = {
            backgroundImage: `url(${configuration.get(
                "configData.common_bg_image"
            )})`
        };
        const {
            data,
            loading,
            activeProfile,
            imagePreviewUrl,
            addNewProfileOption,
            thumbnailLoading,
            profileThumbnail,
        } = this.state;
        let renderData;
        if (this.state.renderManageProfile === 1) {
            renderData = (
                <div className="main">
                    <div className="view-profile">
                        <div className="edit-profile-content edit-profile-content--rails">
                            <div className="head-section">
                                <h1 className="view-profiles-head">
                                    {t("edit")} {t("profile")}
                                </h1>
                            </div>
                            <form onSubmit={this.handleSubmit}>
                                <div className="edit-profile-sec">
                                    <div className="display-inline">
                                        <div className="edit-left-sec">
                                            <div className="edit-profile-imgsec profile-selector__preview">
                                                <img
                                                    src={
                                                        imagePreviewUrl
                                                            ? imagePreviewUrl
                                                            : resolveProfilePicture(
                                                                  data.picture,
                                                                  configuration.get("configData")
                                                              )
                                                    }
                                                    alt={data.name}
                                                />
                                                <div className="edit-icon">
                                                    <div className="edit-icon-circle">
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            accept="image/*"
                                                            onChange={
                                                                this
                                                                    .handleChangeImage
                                                            }
                                                            name="picture"
                                                        />

                                                        <div class="image-upload">
                                                            <label for="file-input">
                                                                <i className="fas fa-pencil-alt" />
                                                            </label>
                                                            <input
                                                                id="file-input"
                                                                type="file"
                                                                accept="image/*"
                                                                onChange={
                                                                    this
                                                                        .handleChangeImage
                                                                }
                                                                name="picture"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="edit-right-sec">
                                            <div className="row">
                                                <div className="col-8">
                                                    <div className="form-group">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            onChange={this.handleChange}
                                                            name="name"
                                                            value={data.name}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-8">
                                                    <div className="form-group">
                                                        <input
                                                            type="text"
                                                            placeholder="Age"
                                                            className="form-control"
                                                            onChange={this.handleChange}
                                                            name="age"
                                                            value={data.age}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {thumbnailLoading ? '' : (
                                    <ProfileImageRails
                                        categories={profileThumbnail}
                                        selectedId={data.thumbnail_id}
                                        onSelect={this.handleChange}
                                        idPrefix="edit"
                                    />
                                )}
                                <div className="button-topspace">
                                    <button
                                        type="submit"
                                        className="white-btn"
                                        disabled={this.state.buttonDisable}
                                    >
                                        {this.state.loadingContent != null
                                            ? this.state.loadingContent
                                            : "save"}
                                    </button>
                                    <Link
                                        to="#"
                                        onClick={this.backToManageProfile}
                                        className="grey-outline-btn"
                                    >
                                        {t("cancel")}
                                    </Link>
                                    <Link
                                        to="#"
                                        onClick={event =>
                                            this.handleDelete(
                                                event,
                                                data.sub_profile_id
                                            )
                                        }
                                        className="grey-outline-btn"
                                    >
                                        {t("delete_profile")}
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            );
        } else if (this.state.renderAddProfile === 1) {
            renderData = (
                <div className="main">
                    <div className="view-profile">
                        <div className="edit-profile-content edit-profile-content--rails">
                            <div className="head-section">
                                <h1 className="view-profiles-head">
                                    {t("add")} {"profile"}
                                </h1>
                            </div>
                            <form onSubmit={this.handleAddProfileSubmit}>
                                <div className="edit-profile-sec">
                                    <div className="display-inline">
                                        <div className="edit-left-sec">
                                            <div className="edit-profile-imgsec profile-selector__preview">
                                                <img
                                                    src={
                                                        imagePreviewUrl
                                                            ? imagePreviewUrl
                                                            : resolveDefaultProfileImage(
                                                                  configuration.get("configData")
                                                              )
                                                    }
                                                    alt={data.name}
                                                />
                                                <div className="edit-icon">
                                                    <div className="edit-icon-circle">
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            className="form-control"
                                                            onChange={
                                                                this
                                                                    .handleChangeImage
                                                            }
                                                            name="picture"
                                                        />
                                                        <div class="image-upload">
                                                            <label for="file-input">
                                                                <i className="fas fa-pencil-alt" />
                                                            </label>
                                                            <input
                                                                id="file-input"
                                                                type="file"
                                                                accept="image/*"
                                                                onChange={
                                                                    this
                                                                        .handleChangeImage
                                                                }
                                                                name="picture"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="edit-right-sec">
                                            <div className="row">
                                                <div className="col-8">
                                                    <div className="form-group">
                                                        <input
                                                            type="text"
                                                            placeholder="Name"
                                                            className="form-control"
                                                            onChange={this.handleChange}
                                                            name="name"
                                                            value={data.name}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-8">
                                                    <div className="form-group">
                                                        <input
                                                            type="text"
                                                            placeholder="Age"
                                                            className="form-control"
                                                            onChange={this.handleChange}
                                                            name="age"
                                                            value={data.age}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {thumbnailLoading ? '' : (
                                    <ProfileImageRails
                                        categories={profileThumbnail}
                                        selectedId={data.thumbnail_id}
                                        onSelect={this.handleChange}
                                        idPrefix="add"
                                    />
                                )}
                                <div className="button-topspace">
                                    <button type="submit" className="white-btn">
                                        {t("save")}
                                    </button>
                                    <Link
                                        to="#"
                                        onClick={this.backToManageProfile}
                                        className="grey-outline-btn"
                                    >
                                        {t("cancel")}
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            );
        } else {
            renderData = (
                <div className="main">
                    <div className="view-profile">
                        <div className="view-profile-content">
                            <div className="head-section">
                                <h1 className="view-profiles-head">
                                    {t("manage_profiles")}
                                </h1>
                            </div>
                            <ul className="choose-profile profile-selector">
                                {loading
                                    ? t("loading")
                                    : this.renderProfile(activeProfile)}
                                {loading ? (
                                    ""
                                ) : addNewProfileOption == 1 ? (
                                    <li className="profile profile-selector__item--add">
                                        <Link to="#" onClick={this.addProfile}>
                                            <div className="relative profile-selector__avatar profile-selector__avatar--add">
                                                <span
                                                    className="profile-selector__add-icon"
                                                    aria-hidden="true"
                                                />
                                            </div>
                                            <p className="profile-name">
                                                {t("add_profile")}
                                            </p>
                                        </Link>
                                    </li>
                                ) : (
                                    ""
                                )}
                            </ul>
                            <div>
                                <Link to="/view-profiles" className="white-btn">
                                    {t("done")}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            // <div className="common-bg-img" style={bgImg}>
            <div
                className="common-bg-img common-bg-1"
                style={profileRailAppearanceStyle(configuration.get("configData"))}
            >
                <StandalonePageHeader variant="account">
                    <StandalonePageLogo linkTo="/home" />
                </StandalonePageHeader>
                {renderData}
            </div>
        );
    }
}

export default withToastManager(translate(ManageProfilesComponent));
